<template>
  <div class="myPageAd" @click.prevent="$emit('click')">
    <i class="myPageAd__icon budicon-announcement"></i>
    <div class="d-flex flex-column">
      <h6>{{ letting.ad.title }}</h6>
      <p>{{ letting.rentalObject.street }} - {{ letting.rentalObject.alias }}</p>
      <div class="myPageAd__metrics">
        <div>
          <i class="budicon budicon-user-favorite mr-2" />
          Interessenter:
        </div>
        <div>
          {{ letting.interestManagement.candidates.total }}
          <template v-if="letting.interestManagement.candidates.new" class="ml-1">
            ({{ letting.interestManagement.candidates.new }} nye)
          </template>
        </div>
        <template v-if="letting.interestManagement.candidates.unread_messages">
          <div>
            <i class="budicon budicon-email mr-2" />
            Uleste meldinger:
          </div>
          <div>
            {{ letting.interestManagement.candidates.unread_messages }}
          </div>
        </template>
      </div>
    </div>
    <span class="myPageAd__chevron">
      <i class="budicon-chevron-right" />
    </span>
  </div>
</template>

<script>
export default {
  name: 'MyPageAd',
  props: {
    letting: Object,
  },
};
</script>

<style scoped lang="scss">
.myPageAd {
  display: grid;
  gap: 1rem;
  align-items: center;
  padding: 1.5rem;
  border: 1px solid $gray-200;
  border-radius: $border-radius;
  cursor: pointer;
}
.myPageAd__icon {
  font-size: 1.8rem;
}
.myPageAd__metrics {
  display: grid;
  grid-template-columns: repeat(2, max-content);
  align-items: center;
  gap: 0.5rem;

  > div {
    display: flex;
    align-items: center;
  }
}
.myPageAd__chevron {
  font-size: 1.5rem;
  display: none;
  text-align: right;
}

@media (min-width: 500px) {
  .myPageAd {
    grid-template-columns: 80px 11fr 1fr;
    gap: 0;
  }
}

@media (min-width: 767px) {
  .myPageAd__chevron {
    display: block;
  }
}
</style>
